import { Link } from "react-router-dom";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function CitiesWeServe() {
  return (
    <>
      <section 
        className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
        style={{
          backgroundImage: 'url(blog13.png)',
        }}
      >
        <Header/>

        {/* Hero Content */}
        <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
          <div className="max-w-5xl text-center text-white">
            <h1 className="font-bold leading-snug text-white">
              Trusted Transportation Services Across Multiple States
            </h1>
            <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
              <a href="/" className="hover:text-logo-green">Home</a>
              <span>-</span>
              <span className="text-logo-green">Cities</span>
            </div>
          </div>
        </div>
      </section>

      {/* Areas We Serve Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="font-bold text-black mb-4">
              Areas We Serve Across Multiple States
            </h2>
            <div className="w-24 h-1 bg-logo-green mx-auto"></div>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div>
              <p className="text-gray-900 mb-3 leading-relaxed">
                We proudly provide top-quality limo services, airport pick and drop, wedding transport, event shuttles, and corporate transportation across New York City, Connecticut, New Jersey, Pennsylvania, Washington D.C., and Rhode Island.
              </p>
              <p className="text-gray-900 leading-relaxed">
                Each area we serve receives the same reliable, clean, and professional experience from our team. Whether it's a quick airport run or a luxury ride for your big day, we make sure your travel is smooth and stress-free.
              </p>
            </div>

            {/* Image/Illustration */}
            <div className="flex justify-center">
              <div className="relative w-full max-w-md">
                <img 
                  src="city1.webp" 
                  alt="New Jersey map with service areas highlighted" 
                  className="rounded-lg shadow-xl"
                />
                <div className="absolute -bottom-4 -right-4 bg-logo-green text-white px-6 py-3 rounded-lg shadow-lg">
                  <span className="font-bold text-lg">6 States</span>
                  <p className="text-sm">Served Across Region</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cities Grid Section */}
      <section className="bg-white py-5 px-5 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { name: "New York City", route: "/new-york-city", image: "city1.webp", state: "NY" },
              { name: "Connecticut", route: "/connecticut", image: "city2.webp", state: "CT" },
              { name: "New Jersey", route: "/new-jersey", image: "city3.webp", state: "NJ" },
              { name: "Pennsylvania", route: "/pennsylvania", image: "city4.webp", state: "PA" },
              { name: "Washington D.C.", route: "/washington-dc", image: "city5.webp", state: "DC" },
              { name: "Rhode Island", route: "/rhode-island", image: "city1.webp", state: "RI" }
            ].map((city, index) => (
              <div key={index} className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                <div className="h-64 overflow-hidden bg-gray-200">
                  <img 
                    src={city.image} 
                    alt={`${city.name} transportation`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                    }}
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-bold text-black mb-4">{city.name}, {city.state}</h3>
                  <p className="text-gray-900 mb-4 leading-relaxed">
                    We offer reliable transportation services in {city.name} for all occasions. From classy limousines to efficient airport transfers, we ensure your ride is smooth and stylish.
                  </p>
                  
                  <Link to={city.route} className="inline-block bg-black border-2 border-white text-white px-5 py-3 font-semibold hover:bg-gray-900 transition-colors">
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FAQ/>
      <Footer/>
    </>
  );
}

export default CitiesWeServe;
